import ReferenceRate from "./ReferenceRate";
class FloatingRate {
    floor;
    margin;
    referenceRate;
    constructor(response) {
        this.floor = response.floor;
        this.margin = response.margin;
        this.referenceRate = response.referenceRate !== undefined ? new ReferenceRate(response.referenceRate) : undefined;
    }
    print() {
        if (this.referenceRate !== undefined && this.margin !== undefined) {
            const items = [];
            items.push(this.referenceRate.printShort());
            const margin = this.margin === 0 ? 'flat' : `${this.margin > 0 ? '+' : ''}${this.margin.toString()}`;
            items.push(margin);
            return items.join(' ');
        }
        return undefined;
    }
}
export default FloatingRate;
